"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Context = require("@emcasa/ui/lib/components/Slider/Context");

var _Row = _interopRequireDefault(require("../Row"));

var _Track = _interopRequireDefault(require("./Track"));

var _MarkerTrack = _interopRequireDefault(require("./MarkerTrack"));

var _popmotion = require("popmotion");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  width: 100%;\n  height: 2px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = (0, _styledComponents["default"])(_Row["default"])(_templateObject());
var initialValue = (0, _popmotion.value)(0);

var SliderTrackContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(SliderTrackContainer, _PureComponent);

  function SliderTrackContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, SliderTrackContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(SliderTrackContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderMarkerTrack", function (marker, index) {
      var trackProps = marker.element.props.trackProps;
      if (!trackProps) return;
      var prevMarker = index > 0 ? _this.props.markers[index - 1] : undefined;
      return _react["default"].createElement(_MarkerTrack["default"], (0, _extends2["default"])({
        key: marker.key,
        zIndex: _this.props.markers.length - index + 1,
        x: marker.state.animatedValues.x,
        offset: prevMarker ? prevMarker.state.animatedValues.x : initialValue
      }, _this.props.trackProps, trackProps));
    });
    return _this;
  }

  (0, _createClass2["default"])(SliderTrackContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          markers = _this$props.markers,
          trackProps = _this$props.trackProps;
      return _react["default"].createElement(Container, null, markers && markers.map(this.renderMarkerTrack), _react["default"].createElement(_Track["default"], (0, _extends2["default"])({
        zIndex: 0
      }, trackProps)));
    }
  }]);
  return SliderTrackContainer;
}(_react.PureComponent);

(0, _defineProperty2["default"])(SliderTrackContainer, "defaultProps", {
  markers: [],
  sliderLayout: {},
  trackProps: {}
});

var _default = (0, _Context.withSliderContext)(function (_ref) {
  var markers = _ref.markers,
      layout = _ref.layout;
  return {
    markers: markers,
    sliderLayout: layout
  };
})(SliderTrackContainer);

exports["default"] = _default;